class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.handles = [];
      this.querySelectorAll(".product-swatch").forEach((swatch) => {
        this.handles.push(swatch.getAttribute("data-handle"));
      });
      this.getAllProducts(this.handles);
      this.products_images = [
        {
            "id": 7138427371708,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/WOOSTER-JEANS-Dark-BLUE.png?v=1675206741"
        },
        {
            "id": 7138426486972,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/WOOSTER-JEANS-Light-medium-BLUE.png?v=1675206741"
        },
        {
            "id": 7372655460540,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/WOOSTER-JEANS-medium-BLUE.png?v=1675206741"
        },
        {
            "id": 7138521383100,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE-jeans-MEDIUM-DARK-BLUE.png?v=1675225578"
        },
        {
            "id": 7138521252028,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE-jeans-MEDIUM-BLUE.png?v=1675225578"
        },
        {
            "id": 7378844745916,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE_jeans_Dark_BLUE.png?v=1675225577"
        },
        {
            "id": 7136730153148,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE-jeans-MEDIUM-DARK-BLUE.png?v=1675225578"
        },
        {
            "id": 7136729923772,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE-jeans-MEDIUM-BLUE.png?v=1675225578"
        },
        {
            "id": 7372639043772,
            "src": "https://cdn.shopify.com/s/files/1/0578/7385/8748/files/STAPLE_jeans_Dark_BLUE.png?v=1675225577"
        },
      ];
    }
  
    updateProductCard(newHandle) {
      const product = this.getProductData(newHandle);
      this.querySelector('.card-image-wrapper > a').href=`/products/${product.handle}`;
      console.log(product.handle);
      var img_src = '';
      this.products_images.forEach(img => {
        if(img.id == product.id){
            img_src = img.src;
        }
      });
      this.updateProductCardImg(img_src ? img_src: product.featured_image);
      this.updateProductCardColor(product);
      this.updateProductCardPrice(product);
      this.updateProductSaleBadge(product);
      this.updateProductStockBadge(product.handle);
    }
    
    updateProductSaleBadge(product) {
        if(product.compare_at_price) {
        if(this.querySelector(".card__badge")) this.querySelector(".card__badge").innerHTML = '<span class="badge badge--bottom-left color-accent-2" aria-hidden="true">Sale</span>';
      } else {
        if(this.querySelector(".card__badge")) this.querySelector(".card__badge").innerHTML = '';
      }
    }
    
    updateProductStockBadge(product_handle) {
      fetch(`/products/${product_handle}?view=inventory`)
        .then(response => response.json())
        .then(data => {
          if(data.badge) {
            this.querySelector(".product_badge").innerHTML = "Low Stock";
            this.querySelector(".product_badge").style.display = 'block';
          } else {
            this.querySelector(".product_badge").innerHTML = "";
            this.querySelector(".product_badge").style.display = 'none';
          }
        });
    }
  
    updateProductCardImg(secondarySrc) {
      const featuredImg = this.querySelector(".featured-card-image");
      function getSrcWithSize(imageSrc) {
        const imageReg = /(.jpg|.png|.jpeg)/g;
        const insertIndex = imageSrc.search(imageReg);
        const srcSize =
          imageSrc.slice(0, insertIndex) +
          `_${featuredImg.width+100}x${featuredImg.height+100}` +
          imageSrc.slice(insertIndex);
  
        return srcSize;
      }
  
      if(featuredImg) featuredImg.srcset = getSrcWithSize(secondarySrc);
    }
  
    updateProductCardColor(product) {
      const color = product.options.find((option) => option.name == "Color");
      this.querySelectorAll(".product-color").forEach(colorElement => {
        colorElement.textContent = color.values[0].split('+').join(', ');
      })
    }
  
    updateProductCardPrice(product) {
      if(product.compare_at_price) {
        if(this.querySelector(".price-item.price-item--sale")) this.querySelector(".price-item.price-item--sale").textContent = ' $' + (product.price / 100) + ' ';
        if(this.querySelector(".price-item.old-price")) this.querySelector(".price-item.old-price").textContent = ' $' + (product.compare_at_price / 100) + ' ';
        this.querySelector(".price .price__regular").style.display = "none";
        this.querySelector(".price .price__sale").style.display = "flex";
      } else {
        if(this.querySelector(".price-item--regular")) this.querySelector(".price-item--regular").textContent = ' $' + (product.price / 100) + ' ';
        this.querySelector(".price .price__sale").style.display = "none";
        this.querySelector(".price .price__regular").style.display = "flex";
      }
    }
  
    getProductData(handle) {
      const scriptID = this.getAttribute("data-json-script-id");
      const data = JSON.parse(document.getElementById(scriptID).textContent);
      const product = data.find((product) => product.handle === handle);
      return product;
    }
  
    static get observedAttributes() {
      return ["data-selected-swatch"];
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null) return;
      this.updateProductCard(newValue);
    }
  
    storeRelatedProductsJSON(data) {
      const scriptID = this.getAttribute("data-json-script-id");
      const script = this.querySelector(`#${scriptID}`);
      script.textContent = JSON.stringify(data);
    }
  
    getAllProducts(handles) {
      const productPromises = [];
  
      for (let handle of handles) {
        productPromises.push(
          fetch(`/products/${handle}.js`)
            .then((response) => response.json())
            .then((data) => data)
            .catch((err) => {
              console.error(err);
            })
        );
      }
  
      Promise.allSettled(productPromises).then((results) => {
        const products = [];
        results.forEach((result) => {
          if (result.status === "fulfilled") products.push(result.value);
        });
        this.storeRelatedProductsJSON(products);
      });
    }
  }
  
  customElements.define("product-card", ProductCard);
  
  class QuickAdd extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".quick-add-option-value").forEach((option) => {
        option.addEventListener("click", this.handleOptionChange.bind(this));
      });
      this.optionsToSelect = this.querySelectorAll(".quick-add-option").length;
      this.selectedOptions = 0;
  
      window.addEventListener('load', () => {
        this.querySelectorAll('.ds-stretch-fit.skinny .quick-add-option-values[data-option-name="Inseam"] span').forEach((option)=>{
          if(option.innerHTML == 32) {
            option.click()
          }
        })
        setTimeout(() => {
          if(this.optionsToSelect == 1) {
            this.querySelectorAll(".quick-add-option-value").forEach((option) => {
              const handle = this.selectedProductHandle;
              const products = JSON.parse(
                option.closest("product-card").querySelector("script").textContent
              );
              const selectedProduct = products.find((data) => data.handle === handle);
  
              const product = selectedProduct;
              const position = option.parentElement.getAttribute("data-option-position");
              const value = option.textContent;
              const filterOptionPosition = position;
  
  
              const availableOptions = product.variants
                .filter((variant) => variant[position] == value && variant.available)
                .map((variant) => variant[filterOptionPosition]);
  
              availableOptions.includes(option.textContent)
                ? option.classList.remove("unavailable")
                : option.classList.add("unavailable");
            });
          }
        },1000);
      });
    }
  
    static get observedAttributes() {
      return ["data-selected-swatch"];
    }
  
    get selectedProductHandle() {
      return this.getAttribute("data-selected-swatch");
    }
  
    renderNewOptions() {
      const selectedProduct = this.getSelectedProduct();
      this.selectedOptions = 0;
      selectedProduct.options.forEach((option) => {
        if (option.name !== "Color") {
          const optionsContainer = this.querySelector(
            `[data-option-name="${option.name}"]`
          );
          const newOptions = [];
          option.values.forEach((value) => {
            const option = document.createElement("span");
            option.classList.add("quick-add-option-value");
            option.textContent = value;
            option.addEventListener("click", this.handleOptionChange.bind(this));
            newOptions.push(option);
          });
          optionsContainer.replaceChildren(...newOptions);
        }
      });
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null) return;
      this.renderNewOptions();
    }
  
    getSelectedProduct() {
      const handle = this.selectedProductHandle;
      const products = JSON.parse(
        this.closest("product-card").querySelector("script").textContent
      );
      const selectedProduct = products.find((data) => data.handle === handle);
      return selectedProduct;
    }
  
    showAvailableOptions(option) {
      const product = this.getSelectedProduct(option);
      const position = option.parentElement.getAttribute("data-option-position");
      const value = option.textContent;
      const filterOptionPosition = position === "option2" ? "option3" : "option2";
  
      const availableOptions = product.variants
        .filter((variant) => variant[position] == value && variant.available)
        .map((variant) => variant[filterOptionPosition]);
  
      if (!option.classList.contains("selected")) {
        return this.querySelectorAll(
          `[data-option-position="${filterOptionPosition}"] .quick-add-option-value`
        ).forEach((option) => {
          option.classList.remove("unavailable");
        });
      }
  
      this.querySelectorAll(
        `[data-option-position="${filterOptionPosition}"] .quick-add-option-value`
      ).forEach((option) => {
        availableOptions.includes(option.textContent)
          ? option.classList.remove("unavailable")
          : option.classList.add("unavailable");
      });
    }
  
    getSelectedProductID() {
      const options = [];
      this.querySelectorAll(".selected").forEach((option) => {
        options.push(option.textContent);
      });
  
      const optionsTitle = options.join(" / ");
      const product = this.getSelectedProduct();
  
      const selectedVariant = product.variants.find((variant) =>
        variant.title.includes(` ${optionsTitle}`)
      );
  
      return selectedVariant.id;
    }
  
    getProductFinalSaleBage() {
      const product = this.getSelectedProduct();
      let finalSale = false;
      if(product.tags.includes('mens-final-sale') || product.tags.includes('womens-final-sale'))
        finalSale = true;
      return finalSale;
    }
  
    addProductToCart() {
      const id = this.getSelectedProductID();
      const finalSale = this.getProductFinalSaleBage();
      const finalSaleProps = finalSale ? { _final_sale: 'yes' } : { _final_sale: 'no' };
      const sideCart = document.querySelector("side-cart");
  
      new Promise((resolve, reject) => {
        resolve(sideCart.addToCart(id, 1, finalSaleProps));
      }).then(() => {
        document.querySelector('.loader').classList.remove('show');
        sideCart.openCart();
        this.renderNewOptions();
      });
    }
  
    handleOptionChange(e) {
      const option = e.target;
      const prevSelectedOption = option.parentElement.querySelector(".selected");
      if (prevSelectedOption) {
        prevSelectedOption.classList.remove("selected");
        --this.selectedOptions;
      }
  
      if (!option.isEqualNode(prevSelectedOption)) {
        option.classList.add("selected");
        ++this.selectedOptions;
      }
  
      this.showAvailableOptions(option);
  
      if (this.selectedOptions === this.optionsToSelect) {
        if(this.constructor.name === 'MobileQuickAdd') {
          this.querySelector('.mobile-quick-add-options__wrapper').classList.remove('open');
          this.querySelector('.mobile-quick-add-btn').classList.remove('open');
        }
        document.querySelector('.loader').classList.add('show');
        return this.addProductToCart();
      }
    }
  }
  
  customElements.define("quick-add", QuickAdd);
  
  class MobileQuickAdd extends QuickAdd {
    constructor() {
      super();
      this.querySelector(".mobile-quick-add-btn").addEventListener(
        "click",
        this.showMobileOptions.bind(this)
      );
    }
  
    showMobileOptions(e) {
      document.querySelectorAll('mobile-quick-add .mobile-quick-add-options__wrapper').forEach((el) => {
        if(el != e.target.previousElementSibling)
          el.classList.remove('open');
      })
      document.querySelectorAll('mobile-quick-add .mobile-quick-add-btn').forEach((el) => {
        if(el != e.target)
          el.classList.remove('open');
      });
      const mobileOptions = e.target.previousElementSibling;
      e.target.classList.toggle("open");
      mobileOptions.classList.toggle("open");
    }
  }
  
  customElements.define("mobile-quick-add", MobileQuickAdd);
  
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll(".product-swatch");
      this.swatches.forEach((swatch) => {
        swatch.addEventListener("click", this.handleSwatchChange.bind(this));
      });
    }
  
    updateSelectedSwatchClass(targetSwatch) {
      this.swatches.forEach((swatch) => {
        swatch.classList.remove("swatch-selected");
      });
  
      targetSwatch.classList.add("swatch-selected");
    }
  
    get selectedProductHandle() {
      return this.closest("product-card").querySelector('quick-add').getAttribute("data-selected-swatch");
    }
  
    updateAttributes(handle) {
      const productCard = this.closest("product-card");
      const quickAdd = productCard.querySelector("quick-add");
      const mobileQuickAdd = productCard.querySelector("mobile-quick-add");
      productCard.setAttribute("data-selected-swatch", handle);
      quickAdd.setAttribute("data-selected-swatch", handle);
      mobileQuickAdd.setAttribute("data-selected-swatch", handle);
  
      if(quickAdd.querySelectorAll('.quick-add-option').length == 1) {
        productCard.querySelectorAll(".quick-add-option-value").forEach((option) => {
          const handle = this.selectedProductHandle;
          const products = JSON.parse(
            option.closest("product-card").querySelector("script").textContent
          );
          const selectedProduct = products.find((data) => data.handle === handle);
  
          const product = selectedProduct;
          const position = option.parentElement.getAttribute("data-option-position");
          const value = option.textContent;
          const filterOptionPosition = position;
  
  
          const availableOptions = product.variants
            .filter((variant) => variant[position] == value && variant.available)
            .map((variant) => variant[filterOptionPosition]);
  
          availableOptions.includes(option.textContent)
            ? option.classList.remove("unavailable")
            : option.classList.add("unavailable");
        });
      }
    }
  
    handleSwatchChange(e) {
      const swatch = e.target.closest(".product-swatch");
      const handle = swatch.getAttribute("data-handle");
  
      if (swatch.classList.contains("swatch-selected")) return;
  
      this.updateSelectedSwatchClass(swatch);
      this.updateAttributes(handle);
    }
  }
  
  customElements.define("product-swatch", ProductSwatch);
  